import React from 'react';

import {
  Done, PriorityHigh,
} from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

import { SaveStatusContainer, StatusText } from './index.styles';

interface SaveStatusProps {
  isLoading: boolean,
  isSuccess: boolean,
  isError: boolean,
}

const SaveStatus = ({ isLoading, isSuccess, isError }: SaveStatusProps) => {
  const renderStatus = () => {
    if (isLoading) {
      return (
        <>
          <CircularProgress size={24} color="inherit" />
          <StatusText>Saving</StatusText>
        </>
      );
    }
    if (isSuccess) {
      return (
        <>
          <Done />
          <StatusText>Saved</StatusText>
        </>
      );
    }
    if (isError) {
      return (
        <>
          <PriorityHigh />
          <StatusText>Error saving</StatusText>
        </>
      );
    }
    return null;
  };

  return <SaveStatusContainer>{renderStatus()}</SaveStatusContainer>;
};

export default SaveStatus;
